import React from "react";
import { Link } from "react-router";

interface Props {
  claimId: string | number | boolean | number[] | string[] | object | object[];
}

const ResponseLinkSegment: React.FC<Props> = (props: Props) => {
  return (
    <div className="response-segment">
      <div className="segment-name">Response Link</div>
      <div className="row">
        <div className="col">
          <Link to={`/claims-search/${props.claimId}`}><>Saved as Claim #{props.claimId}</></Link>
        </div>
      </div>
    </div>
  );
};

export default ResponseLinkSegment;
